import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './preview_header.less'
import { getI18n } from 'client/i18n'
import { Link, withRouter } from 'react-router'
import { routerShape } from 'react-router/lib/PropTypes'
import { glimpseRoute } from 'lib/route_utils'

import BackButton from 'components/common/back_button'
import Separator from 'components/common/separator'

const i18n = getI18n('components/preview_header')

class PreviewHeader extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onBeforeClose: PropTypes.func,
    children: PropTypes.any,
    router: routerShape.isRequired,
    userHasCampaigns: PropTypes.bool,
  }

  handleClose = () => {
    this.props.onClose && this.props.onClose() // eslint-disable-line no-unused-expressions
  }

  handleBack = () => {
    this.props.router.goBack()
  }

  render() {
    const toPath = this.props.userHasCampaigns ? 'publish' : 'prepublish'

    const whiteHeaderElement = cssModules(
      () => (
        <div styleName="header-container">
          <div styleName="back-container">
            <BackButton onClick={this.handleBack} />
          </div>
          <span
            className="icon icon-small icon-close-small"
            styleName="x-button"
            onClick={this.handleClose}
          />
          <div styleName="bottom-part">
            <Separator type="dotted" />
            <div styleName="right-part">
              <div styleName="title">{i18n('title')}</div>
              <Link
                data-pa-click="publish"
                data-nemo="mweb_publish"
                to={{
                  pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create/${toPath}`,
                }}
                className="vx_btn visible-xs-block"
                styleName="next-button-mobile"
              >
                {i18n('next')}
              </Link>
              <Link
                to={glimpseRoute('edit')}
                styleName="edit"
                data-pa-click="edit"
              >
                {i18n('edit_details')}
              </Link>
            </div>
            <Link
              data-pa-click="publish"
              data-nemo="publish"
              to={{
                pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create/${toPath}`,
              }}
              className="vx_btn hidden-xs"
              styleName="next-button"
            >
              {i18n('next')}
            </Link>
          </div>
        </div>
      ),
      styles
    )

    return React.cloneElement(React.Children.only(this.props.children), {
      preview: true,
      onClose: this.props.onClose,
      whiteHeaderElement,
    })
  }
}

export default withRouter(PreviewHeader)
